<template>
	<div class="wrap">
		<Banner v-if="detail.cover" :url="detail.cover" @click.native="$router.push('/detail')">
			<div class="d-flex d-flex--middle tips">
				<div class="d-flex__item text">{{ detail.tips }}</div>
				<div class="fs0">
					<img width="114" src="~@/assets/icon_more.png" alt="" />
				</div>
			</div>
		</Banner>

		<!-- <div class="card">
			<div class="d-flex d-flex--middle breif">
				<div class="t mr-40">{{ title1 }}</div>
				<div class="d-flex__item line"></div>
				<div class="num">{{ num }}次播放</div>
			</div>
			<template v-if="rec">
				<div class="d-flex d-flex--middle sec-t">
					{{ title2 }}<img src="~@/assets/home/yun.png" alt="" />
				</div>
				<g-explain @click.native="go(rec.id)" :data="rec"></g-explain>
			</template>
		</div> -->

		<div class="card" v-if="myExplainList.length" style="padding:1vw">
			<div class="sec-t" style="padding:2vw;margin:0 0 1vw">我的讲解<img src="~@/assets/home/yun.png" alt="" /></div>
			<div class="explist" style="padding:2vw">
				<g-explain v-for="(item,index) in myExplainList" :Length="myExplainList.length" :isMyList="true" :data="item" :key="index" @click.native="go(item.id)" />
			</div>
		</div>
		<div class="card">
			<div class="sec-t">全部讲解<img src="~@/assets/home/yun.png" alt="" /></div>
			<g-explain v-for="(item,index) in explainList" :data="item" :key="index" @click.native="go(item.id)" />
		</div>

		<div class="tel">客服电话：<a href="tel:19938100931"> 19938100931 </a></div>
	</div>
</template>
<script type="text/javascript" charset="UTF-8" src="https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js"></script>

<script>
	import Banner from "./banner";
	import {
		mapState
	} from "vuex";

	import Modax from "modax";
	export default {
		components: {
			Banner
		},
		computed: {
			...mapState(["detail", "explainList", "config"]),
			rec() {
				return this.explainList.find(
					(o) => o.hcScenicNarrator && o.hcScenicNarrator.recommend == 1 && o.hcScenicAudioPackage && o
					.hcScenicAudioPackage.recommend == 1
				);
			},
			tel() {
				try {
					return this.config.service_telephone_numbers.value;
				} catch {
					return "";
				}
			},
			title1() {
				try {
					return this.config.xcxtitle.value;
				} catch {
					return "";
				}
			},
			title2() {
				try {
					return this.config.xcxtitle_all.value;
				} catch {
					return "";
				}
			},
			title() {
				try {
					return this.config.xcxtitle_recommend.value;
				} catch {
					return "";
				}
			},
		},
		data() {
			return {
				isAndroid: false,
				num: 0,
				myExplainList: []
			};
		},
		mounted() {
			this.$store.dispatch("LoadExplain");
			this.isEquipment()
			/*this.$http
				.post("/wx/playSumSummary", {
					agent: "weixin",
					audioVersionId: 1001,
					memberId: this.$store.state.user.id,
					placeId: 1001,
					scenicId: this.$store.state.id,
					type: 1,
				})
				.then((data) => {
					this.num = data.playesStart | 0;
				});

			//防止误退出
			var ua = window.navigator.userAgent.toLowerCase();
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
			this.pushHistory();
			//延时监听防止页面刷新时被触发
			// let that = this;
			window.addEventListener("popstate", this.backChange, false);*/

			this.$http
				.post("/wx/GetMyProductList", {
					jid: localStorage.getItem("jid"),
					memberId: this.$store.state.user.id
				})
				.then((data) => {
					this.myExplainList = data
				});
		},
		destroyed() {
			window.removeEventListener('popstate', this.backChange, false) // false阻止默认事件
		},
		methods: {
			isEquipment(){
				let UA = navigator.userAgent,
					isAndroid = /android|adr|linux/gi.test(UA),
					isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid;
				if(localStorage.getItem("code_type")==4){
					this.$router.push({
						name: "Entrance"
					});
					return
				}
				if(isAndroid){
					this.isAndroid = isAndroid;
					this.$router.push({
						name: "Toxcx"
					});
				}
				if(isIOS){
					const hasTip = sessionStorage.getItem("tip");
					if (!hasTip){
						setTimeout(()=>{
							Modax()
								.width("80%")
								.title("提示")
								.content('若您在使用时退出了页面，可在馆内重新扫讲解服务二维码进入，不影响已购买讲解的正常使用。')
								.cancel(false)
								.ok("我知道了")
								.show();
							sessionStorage.setItem("tip", 1);
						},1000)
					}
				}
			},
			pushHistory() {
				var state = {
					title: "title",
					url: ""
				};
				window.history.pushState(state, "title", "");

			},
			backChange() {
				// const that = this
				// console.log('监听到了');
				Modax()
					.width("80%")
					.title("提示")
					.content("是否要退出当前页面，如您在使用时退出了页面，可在园内重新扫码，或关注公众号“金牌导览”（微信号：jinpaidaolan)")
					.cancel(false)
					.ok("已知晓")
					.ok(() => {
						window.close();
						// window.history.go(-1);
						// setTimeout('wx.closeWindow()',50);
						return true;
					})
					.show();
			},
			go(id) {
				this.$router.push({
					name: "Explain",
					params: {
						id,
					},
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.explist{
		display: flex;
		overflow-x: auto;
	}
	.tips {
		color: #fff;
		padding: 20px 28px;
		background: rgba(0, 0, 0, 0.8);

		.text {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		img {
			width: 114px;
		}
	}

	.breif {
		margin-bottom: 47px;
	}

	.t {
		font-size: 36px;
		font-weight: bold;
	}

	.num {
		color: #666666;
	}

	.sec-t {
		margin-bottom: 40px;
		font-size: 32px;
		font-weight: bold;

		img {
			width: 36px;
			margin-left: 14px;
			vertical-align: middle;
		}
	}

	.line {
		background: url(~@/assets/home/line.png) no-repeat center;
		background-size: 100%;
		height: 20px;
	}

	.wrap {
		padding-bottom: 70px;
	}

	.tel {
		color: #666;
		text-align: center;
		line-height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 100;
		background: #f3f0ea;

		&::before {
			content: "";
			width: 32px;
			height: 32px;
			display: inline-block;
			background: url(~@/assets/home/service.png) no-repeat center;
			background-size: 100% 100%;
			margin-right: 10px;
		}
	}
</style>
